import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import * as Dati from '../Dati';
import { NavLink } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, BottoneAPI, CampoPassword, InputNumero, CampoMultiSelezione } from '../components/';
import { CustomDropzone } from "../components/custom/Dropzone/CustomDropzone";

interface IUtenteState {
    Dato: Dati.CRisAPIDatoTipiInfoUtente;
    Gruppi: Dati.Dictionary<boolean>;
    InputFile?: File;
    CartaServizi: Dati.Dictionary<string>;
    Aggiorna: number;
}

export class Utente extends BaseComponent<Glob.IRouteGlobaleProps, IUtenteState> {
    private ID_Utente: number = 0;

    constructor(props: any) {
        super(props);
        this.state = {
            Dato: new Dati.CRisAPIDatoTipiInfoUtente(), Gruppi: {}, InputFile: undefined, CartaServizi: {}, Aggiorna: 1
        };
        this.ID_Utente = (this.props.match.params as any).ID_Utente;
        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfoUtente, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (dati.Dato.ID_Utente > 0) {
                this.setState({ Dato: dati });
                this.ID_Utente = dati.Dato.ID_Utente;
                let menu = 32;

                if (dati.Dato.ID_Utente > 0) {
                    menu = 32;
                }
                var M = Glob.GetMenu();
                M.Main = "Utente";
                M.ID_MenuMain = menu;
                this.props.SetMenu(M);
            }
            else {
                this.state.Dato.Tipi = dati.Tipi;
                this.setState({ Dato: this.state.Dato });
            }
        }
        return false;
    }

    private OnRisCartaServizi(sender: ChiamaAPI, dati: Dati.CRisAPIDizionario<string>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({ CartaServizi: dati.Dati });
        }
        return false;
    }

    private OnRisGruppiUtente(sender: ChiamaAPI, dati: Dati.CRisAPIDizionario<boolean>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({ Gruppi: dati.Dati });
        }
        return false;
    }

    private OnClickBottoneAPI(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError("ERRORE", dati.ErrTesto + "<br />" + (dati.ErrTesti.length > 0 ? dati.ErrTesti[0] : ""));
        } else {
            this.props.history.push("/Utente/" + dati.ID_Chiave);
            let dato: any = this.state;
            dato.Dato.ID_Utente = dati.ID_Chiave;
            this.ID_Utente = dati.ID_Chiave;
            this.setState({ Dato: dato, Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("UTENTE", Trad.TradParam("UtenteSalvatoCorrettamenteConIdUtente{1-S}", [dati.ID_Chiave]));
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError("ERRORE", errore.message);
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        let Gruppi: Dati.CDictionary<boolean> = new Dati.CDictionary<boolean>();
        if (typeof (this.state.Gruppi) == "string")
            Gruppi.LoadFromJSON(this.state.Gruppi);
        else
            Gruppi.LoadFromDictionary(this.state.Gruppi);

        let Dato: Dati.CDatiUtenteGruppi = new Dati.CDatiUtenteGruppi();
        Dato.ID_Utente = this.state.Dato.Dato.ID_Utente;
        Dato.Cognome = this.state.Dato.Dato.Cognome;
        Dato.Email = this.state.Dato.Dato.Email;
        Dato.ID_Anag = this.state.Dato.Dato.ID_Anag;
        Dato.ID_Utente = this.state.Dato.Dato.ID_Utente;
        Dato.Immagine = this.state.Dato.Dato.Immagine;
        Dato.Livello = this.state.Dato.Dato.Livello;
        Dato.Login = this.state.Dato.Dato.Login;
        Dato.Nome = this.state.Dato.Dato.Nome;
        Dato.Password = this.state.Dato.Dato.Password;
        Dato.LinguaNotifiche = this.state.Dato.Dato.LinguaNotifiche;
        Dato.Gruppi = Gruppi.GetDictionary();
        return Dato;
    }

    private OnInvioFileSalva(sender: BottoneAPI): any {
        if (this.state.InputFile != undefined) {
            var FD = new FormData();
            FD.append("file", this.state.InputFile);
            FD.append("ingr", JSON.stringify(this.state.Dato));
            return FD;
        }
        else {
            var FD = new FormData();

            FD.append("ingr", JSON.stringify(this.state.Dato));
            return FD;
        }
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        }
        else {
            let dato: Dati.CRisAPIDatoTipiInfoUtente = this.state.Dato;
            dato.Dato.Immagine = dati.MessaggioDati;
            this.setState({ Dato: dato });
            //if (this.ID_File == 0) {
            //    this.props.history.replace("/file/" + dati.ID_Chiave);
            //}
            //this.props.history.replace("/file/" + (this.props.match.params as any).ID_Chiave);
            //setTimeout(Glob.InfoModaleSuccess("DOCUMENTI", "Documento salvato correttamente"), 500);
            //this.props.history.goBack();
        }
    }

    private OnClickGeneraCartaServizi(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE GENERAZIONE CARTA SERVIZI"), Trad.Trad(dati.ErrTesto));
        }
        else {
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess(Trad.Trad("GENERAZIONE CARTA SERVIZI"), Trad.Trad("GenerazioneCartaServiziAvvenutaConSuccesso"));
        }
    }

    private OnDrop(accepted: File[], rejected: File[]) {
        this.setState({ InputFile: accepted[0] });
    }

    public render() {
        let Lingue: Dati.TDictTipo = {};
        Lingue["IT"] = new Dati.CTipo("IT", "Italiana");
        Lingue["EN"] = new Dati.CTipo("EN", "Inglese");

        if (!this.ControlloAutorizzazione("UtentiController") && !(this.ControlloAutorizzazione("ProprioUtente") && this.ID_Utente == Glob.GetSessione().ID_Utente)) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }
        //console.warn("UTENTE", this.ControlloAutorizzazione("UtentiController"), this.ControlloAutorizzazione("ProprioUtente"), this.ID_Utente, Glob.GetSessione().ID_Utente);

        let CartaServizi: any = <div></div>;
        if (this.state.CartaServizi["1"] != undefined) {
            CartaServizi = <table>
                <tbody>
                    <tr>
                        <th colSpan={8}>{Trad.Trad("CartaServizi")}</th>
                    </tr>
                    <tr>
                        <th>01</th>
                        <td>{this.state.CartaServizi["1"]}</td>
                        <th>02</th>
                        <td>{this.state.CartaServizi["2"]}</td>
                        <th>03</th>
                        <td>{this.state.CartaServizi["3"]}</td>
                        <th>04</th>
                        <td>{this.state.CartaServizi["4"]}</td>
                    </tr>
                    <tr>
                        <th>05</th>
                        <td>{this.state.CartaServizi["5"]}</td>
                        <th>06</th>
                        <td>{this.state.CartaServizi["6"]}</td>
                        <th>07</th>
                        <td>{this.state.CartaServizi["7"]}</td>
                        <th>08</th>
                        <td>{this.state.CartaServizi["8"]}</td>
                    </tr>
                    <tr>
                        <th>09</th>
                        <td>{this.state.CartaServizi["9"]}</td>
                        <th>10</th>
                        <td>{this.state.CartaServizi["10"]}</td>
                        <th>11</th>
                        <td>{this.state.CartaServizi["11"]}</td>
                        <th>12</th>
                        <td>{this.state.CartaServizi["12"]}</td>
                    </tr>
                    <tr>
                        <th>13</th>
                        <td>{this.state.CartaServizi["13"]}</td>
                        <th>14</th>
                        <td>{this.state.CartaServizi["14"]}</td>
                        <th>15</th>
                        <td>{this.state.CartaServizi["15"]}</td>
                        <th>16</th>
                        <td>{this.state.CartaServizi["16"]}</td>
                    </tr>
                    <tr>
                        <th>17</th>
                        <td>{this.state.CartaServizi["17"]}</td>
                        <th>18</th>
                        <td>{this.state.CartaServizi["18"]}</td>
                        <th>19</th>
                        <td>{this.state.CartaServizi["19"]}</td>
                        <th>20</th>
                        <td>{this.state.CartaServizi["20"]}</td>
                    </tr>
                    <tr>
                        <th>21</th>
                        <td>{this.state.CartaServizi["21"]}</td>
                        <th>22</th>
                        <td>{this.state.CartaServizi["22"]}</td>
                        <th>23</th>
                        <td>{this.state.CartaServizi["23"]}</td>
                        <th>24</th>
                        <td>{this.state.CartaServizi["24"]}</td>
                    </tr>
                    <tr>
                        <th>25</th>
                        <td>{this.state.CartaServizi["25"]}</td>
                        <th>26</th>
                        <td>{this.state.CartaServizi["26"]}</td>
                        <th>27</th>
                        <td>{this.state.CartaServizi["27"]}</td>
                        <th>28</th>
                        <td>{this.state.CartaServizi["28"]}</td>
                    </tr>
                    <tr>
                        <th>29</th>
                        <td>{this.state.CartaServizi["29"]}</td>
                        <th>30</th>
                        <td>{this.state.CartaServizi["30"]}</td>
                        <th>31</th>
                        <td>{this.state.CartaServizi["31"]}</td>
                        <th>32</th>
                        <td>{this.state.CartaServizi["32"]}</td>
                    </tr>
                </tbody>
            </table>
        }

        var caricaDocumento = <CustomDropzone OnDrop={this.OnDrop.bind(this)} AcceptedFiles=".jpg, .jpeg, .png" InputFile={this.state.InputFile}
            NoFileMessage={Trad.Trad("CaricaDocumento")} />;
        let Sessione = Glob.GetSessione();
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon "><i className="fa fa-user"></i></span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Anagrafica")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                            <NavLink to="/Utente/0" className={"kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg " + this._VisibileScrittura} title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
            <div className="form-group kt-form login-form__group row form-group-padding-height-25 form-group-padding-width-30">
                <div className="col-xl-3 col-lg-4">
                    <div className="kt-portlet portlet-shadow kt-portlet--full-height  ">
                        <div className="kt-portlet__body">
                            <div className="kt-card-profile">
                                <div className="kt-card-profile__title lt--hide">
                                    {Trad.Trad("il tuo profilo")}
                                </div>
                                <div className="kt-card-profile__pic">
                                    <div className="kt-card-profile__pic-wrapper">
                                        <img src={Compat.ES6_String_startWith(this.state.Dato.Dato.Immagine, 'http') ? this.state.Dato.Dato.Immagine : "/cdn/users/" + this.state.Dato.Dato.Immagine} alt={this.state.Dato.Dato.Nome + ' ' + this.state.Dato.Dato.Cognome} />
                                    </div>
                                </div>
                                <div className="kt-card-profile__details">
                                    <span className="kt-card-profile__name">{this.state.Dato.Dato.Nome + ' ' + this.state.Dato.Dato.Cognome}</span>
                                    <a href={"/Utente/" + this.state.Dato.Dato.ID_Utente} className="kt-card-profile__email kt-link">{this.state.Dato.Dato.Email}</a>
                                </div>
                            </div>
                            <div className="kt-portlet__body-separator"></div>
                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-12">
                                    {caricaDocumento}
                                </div>
                            </div>
                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-6">
                                    <BottoneAPI InviaFile Default Testo={Trad.Trad("Upload")} URL="/api/file/UploadImmagineProfilo" Metodo="POST" OnInvio={(s) => this.OnInvioFileSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} />
                                </div>
                                <div className="col-lg-6">
                                    <BottoneAPI Testo={Trad.Trad("GeneraCartaServizi")} URL={"/api/utenti/GeneraCartaServizi?ID_Utente=" + this.ID_Utente} Metodo="GET" OnClick={(s, d) => this.OnClickGeneraCartaServizi(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={Glob.GetSessione().Gruppi.indexOf("1") >= 0} />
                                </div>
                            </div>
                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-12">
                                    {CartaServizi}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-9 col-lg-8">
                    <div className="kt-portlet portlet-shadow kt-portlet--full-height kt-portlet--tabs">
                        <div className="kt-portlet__head">
                            <div className="portlet__head-tools">
                                <ul className="nav nav-tabs kt-tabs kt-tabs-line kt-tabs-line--left kt-tabs-line--brand" role="tablist">
                                    <li className="nav-item kt-tabs__item">
                                        <a className="nav-link tabs__link active show" data-toggle="tab" href="#kt_user_profile_tab_1" role="tab" aria-selected="true">
                                            <i className="flaticon-share lt--hide"></i>
                                            {Trad.Trad("Profilo utente")}
                                        </a>
                                    </li>
                                    <li className={this.state.Gruppi == {} ? "nav-item kt-tabs__item hidden" : "nav-item kt-tabs__item"}>
                                        <a className="nav-link tabs__link" data-toggle="tab" href="#kt_user_profile_tab_2" role="tab" aria-selected="false">
                                            {Trad.Trad("Gruppi")}
                                        </a>
                                    </li>
                                    <li className="nav-item kt-tabs__item hidden">
                                        <a className="nav-link tabs__link" data-toggle="tab" href="#kt_user_profile_tab_3" role="tab" aria-selected="false">
                                            {Trad.Trad("Calendario")}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="tab-content">
                            <div className="tab-pane active show" id="kt_user_profile_tab_1">
                                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right">
                                    <div className="kt-portlet__body">

                                        <div className="form-group kt-form login-form__group row">
                                            <div className="col-10 ml-auto">
                                                <h3 className="kt-form login-form__section">1. {Trad.Trad("Dettagli utente")}</h3>
                                            </div>
                                        </div>

                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("ID")}</label>
                                            <div className="col-7">
                                                <input type="text" className="form-control" value={this.state.Dato.Dato.ID_Utente || ""} id="ID_Utente" name="Dato.ID_Utente" onChange={(e) => { this.OnChange(e) }} readOnly />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("Anagrafica")}</label>
                                            <div className="col-7">
                                                <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="Dato.Dato.ID_Anag" ID_Chiave={this.state.Dato.Dato.ID_Anag} OnAggiorna={this.OnChange} TradValori LinkSelezione="/anagrafica/" Disabilitato={(this.state.Dato.Dato.ID_Utente > 0)} />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("Login")}</label>
                                            <div className="col-7">
                                                <input type="text" className="form-control" value={this.state.Dato.Dato.Login || ""} id="Login" name="Dato.Login" onChange={(e) => { this.OnChange(e) }} readOnly={(this.state.Dato.Dato.ID_Utente > 0)} />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("Password")}</label>
                                            <CampoPassword Name="Dato.Password" Id="Dato.Password" OnChange={this.OnChange} Valore={this.state.Dato.Dato.Password} DimensioneCSS={7} />
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("Livello")}</label>
                                            <div className="col-3">
                                                <InputNumero Name="Dato.Livello" Id="Dato.Livello" Valore={this.state.Dato.Dato.Livello} Minimo={1} Massimo={10} Precisione={0} OnChange={this.OnChange} Etichetta="" Disabilitato={(this.state.Dato.Dato.ID_Utente > 0)} />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("Nome")}</label>
                                            <div className="col-7">
                                                <input type="text" className="form-control" value={this.state.Dato.Dato.Nome || ""} id="Nome" name="Dato.Nome" onChange={(e) => { this.OnChange(e) }} />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("Cognome")}</label>
                                            <div className="col-7">
                                                <input type="text" className="form-control" value={this.state.Dato.Dato.Cognome || ""} id="Cognome" name="Dato.Cognome" onChange={(e) => { this.OnChange(e) }} />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("Email")}</label>
                                            <div className="col-7">
                                                <input type="text" className="form-control" value={this.state.Dato.Dato.Email || ""} id="Email" name="Dato.Email" onChange={(e) => { this.OnChange(e) }} readOnly={(this.state.Dato.Dato.ID_Utente > 0)} />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <label className="col-2 col-form-label">{Trad.Trad("LinguaNotifiche")}</label>
                                            <div className="col-7">
                                                <Tipo Dati={Lingue} Campo="Dato.Dato.LinguaNotifiche" ID_ChiaveString={this.state.Dato.Dato.LinguaNotifiche} OnAggiorna={this.OnChange} TradValori />
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <div className="col-8">
                                            </div>
                                            <div className={"col-1"}>
                                                <BottoneAPI Testo={Trad.Trad("Salva")} URL="/api/utenti/" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickBottoneAPI(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} />
                                            </div>
                                        </div>

                                        <div className="kt-form login-form__seperator kt-form login-form__seperator--dashed kt-form login-form__seperator--space-2x hidden"></div>

                                        <div className="form-group kt-form login-form__group row hidden">
                                            <div className="col-10 ml-auto">
                                                <h3 className="kt-form login-form__section">2. {Trad.Trad("Gestione password")}</h3>
                                            </div>
                                        </div>

                                        <div className="form-group kt-form login-form__group row hidden">
                                            <label className="col-2 col-form-label"></label>
                                            <div className="col-7 TextRight">
                                                <BottoneAPI Default Testo={Trad.Trad("Cambia")} URL={`/api/anag/SalvaAnagraficaAsync`} Metodo="POST" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="kt-portlet__foot kt-portlet__foot--fit hidden">
                                        <div className="kt-form login-form__actions">
                                            <div className="row">
                                                <div className="col-2">
                                                </div>
                                                <div className="col-7">
                                                    <button type="reset" className="btn btn-brand kt-btn kt-btn--air kt-btn--custom">Save changes</button>&nbsp;&nbsp;
                                                    <button type="reset" className="btn btn-secondary kt-btn kt-btn--air kt-btn--custom">Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="tab-pane" id="kt_user_profile_tab_2">
                                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right">
                                    <div className="kt-portlet__body">
                                        <div className="form-group kt-form login-form__group row">
                                            <div className="col-10 ml-auto">
                                                <h3 className="kt-form login-form__section">2. {Trad.Trad("Gruppi")}</h3>
                                            </div>
                                        </div>
                                        <div className="form-group kt-form login-form__group row">
                                            <div className="col-2"></div>
                                            <div className="col-7">
                                                <CampoMultiSelezione Id="Gruppi" Name="Gruppi" Valori={this.state.Gruppi} OnChange={(e, v) => { this.OnChange(e, v) }} BloccoAltezza={false} />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ChiamaAPI Aggiornare={this.state.Aggiorna} URL={"/api/Utenti/seleziona?id_utente=" + this.ID_Utente} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
            <ChiamaAPI Aggiornare={this.state.Aggiorna} URL={"/api/Utenti/GetCartaServizi?id_utente=" + this.ID_Utente} OnRis={(s, d, dn) => this.OnRisCartaServizi(s, d, dn)} OnErrore={this.OnErrore} />
            <ChiamaAPI Aggiornare={this.state.Aggiorna} URL={"/api/Utenti/GruppiAttiviUtente?id_utente=" + this.ID_Utente} OnRis={(s, d, dn) => this.OnRisGruppiUtente(s, d, dn)} OnErrore={this.OnErrore} />
        </div >;
    }
}



// WEBPACK FOOTER //
// ./src/form/Utente.tsx